const icons = [
  {
    name: 'link',
  },
  {
    name: 'laptop',
  },
  {
    name: 'access_time',
  },
  {
    name: 'airport_shuttle',
  },
  {
    name: 'alternate_email',
  },
  {
    name: 'assignment',
  },
  {
    name: 'attach_file',
  },
  {
    name: 'book',
  },
  {
    name: 'bookmark',
  },
  {
    name: 'calendar_month',
  },
  {
    name: 'business_center',
  },
  {
    name: 'chat',
  },
  {
    name: 'cloud',
  },
  {
    name: 'euro',
  },
  {
    name: 'favorite',
  },
  {
    name: 'forest',
  },
  {
    name: 'grade',
  },
  {
    name: 'groups',
  },
  {
    name: 'house',
  },
  {
    name: 'home_work',
  },
  {
    name: 'image',
  },
  {
    name: 'keyboard_voice',
  },
  {
    name: 'lightbulb',
  },
  {
    name: 'local_fire_department',
  },
  {
    name: 'mail_outline',
  },
  {
    name: 'photo_camera',
  },
  {
    name: 'rocket',
  },
  {
    name: 'search',
  },
];

export default icons;
